//与百度相关的接口
export default [
  {
    name: 'baiduPlace',
    method: 'get',
    desc: '根据城市名称 关键字获取周边标志地点位置信息',
    path: '/obt/baidu/baiduPlace',
    params: {
      cityName: '',
      keywords:'',
      count:10
    }
  },
  {
    name: 'geocoder',
    method: 'post',
    desc: '根据经纬度获取详细的位置信息',
    path: '/obt/baidu/geocoder',
    params: {
      coordType: 'bd09ll',
      lat: '',
      lng: '',
      urlType: ''
    },
    loading: '0'
  },
  {
    name: 'geocoding',
    method: 'JSONP',
    desc: '地理编码将结构化地址（省/市/区/街道/门牌号）解析为对应的位置坐标。地址结构越完整，地址内容越准确，解析的坐标精度越高',
    path: 'https://api.map.baidu.com/geocoding/v3/',
    params: {
      address: '',
      city:'',
      output: 'json',
      ak: 'hTYjHMb37ukf9DZE5WyiUcjUEhVtIKS7',
    },
    loading: '0'
  }
    
    
]
